import React from "react";
import { IMAGES } from "../../utils/images";

const AnalyticsSection = () => {
    return (
        <section className="bg-white border-y border-[#e4e5e7]">
            <div className="max-w-[1200px] mx-auto px-[16px] md:px-[40px] py-[56px] md:py-[80px]">

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-[32px] lg:gap-[48px] items-center">

                    {/* Left Content */}
                    <div>
                        <p className="font-semibold text-[13px] text-[#ff5323] uppercase mb-[8px]">
                            Insights & analytics
                        </p>

                        <h2 className="font-semibold text-[28px] md:text-[36px] text-[#212326] mb-[12px]">
                            Know your numbers. Grow your business.
                        </h2>

                        <p className="font-medium text-[16px] text-[#717182] leading-[1.7] mb-[32px]">
                            Professional plan shops unlock analytics to understand customers, optimize operations, and grow revenue.
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-[16px]">

                            {/* Revenue tracking */}
                            <div className="flex items-start gap-[12px] p-[16px] rounded-[12px] bg-[#fafafa] border border-[#f0f0f2]">
                                <div className="w-[36px] h-[36px] rounded-[10px] bg-white border border-[#e4e5e7] flex items-center justify-center shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" className="w-[20px] h-[20px] text-[#ff5323]">
                                        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                                        <polyline points="16 7 22 7 22 13" />
                                    </svg>
                                </div>

                                <div>
                                    <p className="font-semibold text-[14px] text-[#212326] mb-[2px]">
                                        Revenue tracking
                                    </p>
                                    <p className="font-medium text-[12px] text-[#717182] leading-[1.5]">
                                        Daily, weekly, and monthly revenue trends at a glance.
                                    </p>
                                </div>
                            </div>

                            {/* Popular services */}
                            <div className="flex items-start gap-[12px] p-[16px] rounded-[12px] bg-[#fafafa] border border-[#f0f0f2]">
                                <div className="w-[36px] h-[36px] rounded-[10px] bg-white border border-[#e4e5e7] flex items-center justify-center shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" className="w-[20px] h-[20px] text-[#ff5323]">
                                        <circle cx="12" cy="12" r="10" />
                                        <circle cx="12" cy="12" r="6" />
                                        <circle cx="12" cy="12" r="2" />
                                    </svg>
                                </div>

                                <div>
                                    <p className="font-semibold text-[14px] text-[#212326] mb-[2px]">
                                        Popular services
                                    </p>
                                    <p className="font-medium text-[12px] text-[#717182] leading-[1.5]">
                                        See which services drive the most orders and enquiries.
                                    </p>
                                </div>
                            </div>

                            {/* Peak hours */}
                            <div className="flex items-start gap-[12px] p-[16px] rounded-[12px] bg-[#fafafa] border border-[#f0f0f2]">
                                <div className="w-[36px] h-[36px] rounded-[10px] bg-white border border-[#e4e5e7] flex items-center justify-center shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" className="w-[20px] h-[20px] text-[#ff5323]">
                                        <circle cx="12" cy="12" r="10" />
                                        <polyline points="12 6 12 12 16 14" />
                                    </svg>
                                </div>

                                <div>
                                    <p className="font-semibold text-[14px] text-[#212326] mb-[2px]">
                                        Peak hours
                                    </p>
                                    <p className="font-medium text-[12px] text-[#717182] leading-[1.5]">
                                        Discover when customers are most active and staff accordingly.
                                    </p>
                                </div>
                            </div>

                            {/* Customer insights */}
                            <div className="flex items-start gap-[12px] p-[16px] rounded-[12px] bg-[#fafafa] border border-[#f0f0f2]">
                                <div className="w-[36px] h-[36px] rounded-[10px] bg-white border border-[#e4e5e7] flex items-center justify-center shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" className="w-[20px] h-[20px] text-[#ff5323]">
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                </div>

                                <div>
                                    <p className="font-semibold text-[14px] text-[#212326] mb-[2px]">
                                        Customer insights
                                    </p>
                                    <p className="font-medium text-[12px] text-[#717182] leading-[1.5]">
                                        Repeat customers, new acquisitions, and retention metrics.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Right Image */}
                    <div className="relative">
                        <div className="rounded-[20px] overflow-hidden border border-[#e4e5e7] shadow-[0px_8px_32px_rgba(0,0,0,0.08)]">
                            <div className="inline-block bg-gray-100 text-center align-middle w-full h-[320px] md:h-[400px] object-cover">
                                <div className="flex items-center justify-center w-full h-full">
                                    <img
                                        src={IMAGES.analytics}
                                        alt="Dashboard analytics"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Floating stats */}
                        <div className="absolute -bottom-[20px] -left-[12px] md:-left-[20px] bg-white rounded-[14px] border border-[#e4e5e7] shadow-[0px_4px_16px_rgba(0,0,0,0.1)] p-[16px] flex items-center gap-[12px]">
                            <div className="w-[40px] h-[40px] rounded-[10px] bg-[#e8f8e8] flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up w-[20px] h-[20px] text-[#2ecc71]">
                                    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                                    <polyline points="16 7 22 7 22 13"></polyline>
                                </svg>
                            </div>
                            <div>
                                <p className="font-semibold text-[18px] text-[#212326]">+34%</p>
                                <p className="font-medium text-[11px] text-[#9298a0]">Orders this month</p>
                            </div>
                        </div>

                        <div className="absolute -top-[12px] -right-[8px] md:-right-[16px] bg-white rounded-[14px] border border-[#e4e5e7] shadow-[0px_4px_16px_rgba(0,0,0,0.1)] p-[16px] flex items-center gap-[12px]">
                            <div className="w-[40px] h-[40px] rounded-[10px] bg-[#fff0ec] flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users w-[20px] h-[20px] text-[#ff5323]">
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>

                                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                            </div>
                            <div>
                                <p className="font-semibold text-[18px] text-[#212326]">127</p>
                                <p className="font-medium text-[11px] text-[#9298a0]">New customers</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AnalyticsSection;